import { formatAsIsoDateAndTime } from "../../core/helpers/date-formatting-util.js";
import Model from "../Model.js";

/**
 * A financial or non-financial data stored. The value is stored for
 * a dimension (or entire business) and a period.
 *
 * @param {string} spec.keyFigureDataId -
 * @param {TimeSpan} spec.period -
 * @param {string} spec.fiscalYearId -
 * @param {string} [spec.dimensionId] -
 * @param {number} spec.value -
 */
export default class KeyFigureData extends Model {
	constructor({ keyFigureDataId, period, dimensionId, fiscalYearId, value }) {
		super(...arguments);
		this._keyFigureDataId = keyFigureDataId;
		this._period = period;
		this._dimensionId = dimensionId;
		this._fiscalYearId = fiscalYearId;
		this._value = value;
	}

	getValue() {
		return this._value;
	}

	setValue(newValue) {
		this._value = newValue;
	}

	getPeriod() {
		return this._period;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.keyFigureDataId = this._keyFigureDataId;

		properties.period = {
			start: formatAsIsoDateAndTime(this._period.getStart()),
			end: formatAsIsoDateAndTime(this._period.getEnd()),
		};

		properties.dimensionId = this._dimensionId;
		properties.fiscalYearId = this._fiscalYearId;
		properties.value = this._value;

		return properties;
	}
}
